/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ReportAverageWeeklyHours
 */
export interface ReportAverageWeeklyHours {
    /**
     * 
     * @type {number}
     * @memberof ReportAverageWeeklyHours
     */
    employeeId: number;
    /**
     * 
     * @type {number}
     * @memberof ReportAverageWeeklyHours
     */
    hoursScheduled: number;
    /**
     * 
     * @type {number}
     * @memberof ReportAverageWeeklyHours
     */
    hoursWorked: number;
    /**
     * 
     * @type {number}
     * @memberof ReportAverageWeeklyHours
     */
    hoursOvertime: number;
}

/**
 * Check if a given object implements the ReportAverageWeeklyHours interface.
 */
export function instanceOfReportAverageWeeklyHours(value: object): value is ReportAverageWeeklyHours {
    if (!('employeeId' in value) || value['employeeId'] === undefined) return false;
    if (!('hoursScheduled' in value) || value['hoursScheduled'] === undefined) return false;
    if (!('hoursWorked' in value) || value['hoursWorked'] === undefined) return false;
    if (!('hoursOvertime' in value) || value['hoursOvertime'] === undefined) return false;
    return true;
}

export function ReportAverageWeeklyHoursFromJSON(json: any): ReportAverageWeeklyHours {
    return ReportAverageWeeklyHoursFromJSONTyped(json, false);
}

export function ReportAverageWeeklyHoursFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportAverageWeeklyHours {
    if (json == null) {
        return json;
    }
    return {
        
        'employeeId': json['employeeId'],
        'hoursScheduled': json['hoursScheduled'],
        'hoursWorked': json['hoursWorked'],
        'hoursOvertime': json['hoursOvertime'],
    };
}

  export function ReportAverageWeeklyHoursToJSON(json: any): ReportAverageWeeklyHours {
      return ReportAverageWeeklyHoursToJSONTyped(json, false);
  }

  export function ReportAverageWeeklyHoursToJSONTyped(value?: ReportAverageWeeklyHours | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employeeId': value['employeeId'],
        'hoursScheduled': value['hoursScheduled'],
        'hoursWorked': value['hoursWorked'],
        'hoursOvertime': value['hoursOvertime'],
    };
}

